import { render, staticRenderFns } from "./BsFarmModule03.vue?vue&type=template&id=597af3eb&scoped=true"
import script from "./BsFarmModule03.vue?vue&type=script&lang=js"
export * from "./BsFarmModule03.vue?vue&type=script&lang=js"
import style0 from "./BsFarmModule03.vue?vue&type=style&index=0&id=597af3eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597af3eb",
  null
  
)

export default component.exports